import { render, staticRenderFns } from "./BackdropLoader.vue?vue&type=template&id=c6e47312&"
import script from "./BackdropLoader.vue?vue&type=script&lang=ts&"
export * from "./BackdropLoader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports